import React from "react";
import PropTypes from "prop-types";
// material import
import Typography from "@mui/material/Typography";
const ErrorSummary = ({
  errors
}) => {
  const getErrorMessage = (err, index) => {
    var _err$errorInfo;
    return /*#__PURE__*/React.createElement(Typography, {
      key: index
    }, ((_err$errorInfo = err.errorInfo) === null || _err$errorInfo === void 0 ? void 0 : _err$errorInfo.message) || err.message);
  };
  if (Array.isArray(errors)) {
    return /*#__PURE__*/React.createElement("div", null, errors.map((err, index) => getErrorMessage(err, index)));
  }
  return /*#__PURE__*/React.createElement("div", null, getErrorMessage(errors, 0));
};
export default ErrorSummary;
ErrorSummary.propTypes = {
  errors: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired
};